<template>
  <div class="mine-course">
    <a-spin :spinning="spinningCourse">
      <div class="course-swiper">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          class="swiper-wrappe carousel"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(c, i) in courseResult"
            :key="i"
          >
            <a-card hoverable>
              <div slot="cover" @click="toUnitMap(c)">
                <img
                  :class="[c.isCourseStart ? '' : 'gray']"
                  :src="c.courseCover_url"
                />
              </div>
              <template slot="actions" class="ant-card-actions">
                <a-row>
                  <a-col :span="8">
                    <a-progress
                      type="dashboard"
                      :stroke-color="{
                        '0%': '#108ee9',
                        '100%': '#908ee9',
                      }"
                      :percent="c.finishedWork / c.totalWork"
                    >
                      <template #format="percent">
                        <a-tooltip :title="c.openTime">
                          <p>
                            {{
                              c.isCourseStart
                                ? "已开课"
                                : (c.openTime ? c.openTime : "未") + "开课"
                            }}
                          </p>
                        </a-tooltip>
                        <p>{{ c.finishedWork }} / {{ c.totalWork }}</p>
                      </template>
                    </a-progress>
                  </a-col>
                  <a-col :span="16">
                    <div @click="toUnitMap(c)">
                      <h3>{{ c.courseName }}</h3>
                      <p>{{ c.courseDesc }}</p>
                    </div>
                  </a-col>
                </a-row>
              </template>
            </a-card>
          </swiper-slide>

          <!-- 分页器 -->
          <div
            v-show="courseResult && courseResult.length > 1"
            class="swiper-pagination swiper-pagination-white"
            slot="pagination"
          ></div>
          <!-- 左右箭头 -->
          <div
            v-show="courseResult && courseResult.length > 1"
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
          ></div>
          <div
            v-show="courseResult && courseResult.length > 1"
            class="swiper-button-next swiper-button-white"
            slot="button-next"
          ></div>
        </swiper>
      </div>
    </a-spin>
    <div class="course-recommend">
      <ActivityGoodsList :status="2" :limit="4"> </ActivityGoodsList>
    </div>
  </div>
</template>

<script>
import {
  getMineCourse,
  getNewCourse,
} from "@/api/course";
import { getDict } from "@/api/sys";
import ActivityGoodsList from "@/components/course/ActivityGoodsList";
export default {
  name: "MineCourse",
  components: {
    ActivityGoodsList,
  },
  data() {
    return {
      swiperOptions: {
        speed: 800,
        effect: "coverflow",
        grabCursor: true,
        watchSlidesProgress: true,
        centeredSlides: true,
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: false,
        loopedSlides: 3,
        slidesPerView: 3,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 50,
          modifier: 6,
          slideShadows: false,
        },
      },
      spinningCourse: true,
      courseResult: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    // this.getCourseType()
    this.getMineCourse();
    this.getNewCourse();
  },
  methods: {
    getCourseType(){
      getDict("courseType").then(res=>{

      })
    },
    getMineCourse() {
      let that = this;
      getMineCourse({}).then((res) => {
        if (res.success) {
          this.spinningCourse = false;
          this.courseResult = res.result;
          //   this.caroulLength = Math.ceil(res.result.length / 3);
        }
      });
    },
    getNewCourse() {
      getNewCourse().then((res) => {
        if (res.success) {
          this.courseSchedule = res.result;
          if (res.result.length > 0) {
            this.newCourse = res.result[0];
          }
        }
      });
    },
    toUnitMap(course) {
      if (course.isCourseStart) {
        if (course.showType == 1) {
          //地图展示
          this.$router.push({
            path: `/center/mineUnitMap?courseId=${course.id}&departId=${course.departId}`,
          });
        } else if (course.showType == 2) {
          //卡片展示
          this.$router.push({
            path: `/center/mineUnitCard?courseId=${course.id}&departId=${course.departId}`,
          });
        } else {
          this.$router.push({
            path: `/center/mineUnitCard?courseId=${course.id}&departId=${course.departId}`,
          });
        }
      } else {
        this.$message.info("未开课");
      }
    },
  },
};
</script>

<style lang="less">
.course-swiper {
  .swiper-wrapper {
    margin: 20px 0;
  }
  .swiper-pagination {
    //   bottom: -30px;
    .swiper-pagination-bullet {
      height: 10px;
      width: 20px;
      border-radius: 3px;
    }
    .swiper-pagination-bullet-active {
      width: 30px;
    }
  }
  .ant-card {
    margin: 20px;
    width: 100%;
    box-shadow: 0px 9px 9px 0px #00000038;

    .ant-card-cover {
      img {
        width: 100%;
      }
    }
    .ant-card-actions {
      padding: 10px 5px;
    }
    .ant-progress-text {
      color: black;
    }
  }
}
.course-recommond {
}
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>